import { useAuth } from "@/contexts/AuthContext";
import { myArtistXP } from "@/mocks/artistData";

export default function StatsCards() {
  const { user } = useAuth();
  if (!user) return null;

  const totalQuestsCompleted = myArtistXP.reduce((sum, a) => sum + a.questsCompleted, 0);
  const followingArtists = myArtistXP.length;

  const stats = [
    {
      icon: "ri-sparkling-2-fill",
      color: "#ff6eb4",
      label: "보유 토큰",
      value: user.tokens.toString(),
      sub: "이번 달 남은 토큰",
    },
    {
      icon: "ri-star-fill",
      color: "#ffd60a",
      label: "총 획득 XP",
      value: user.totalXP.toLocaleString(),
      sub: "전체 누적 경험치",
    },
    {
      icon: "ri-film-line",
      color: "#4fc3f7",
      label: "완료 캠페인",
      value: totalQuestsCompleted.toString(),
      sub: "참여한 캠페인 수",
    },
    {
      icon: "ri-heart-fill",
      color: "#c77dff",
      label: "팔로우 아티스트",
      value: followingArtists.toString(),
      sub: "활동 중인 IP",
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
      {stats.map((s) => (
        <div
          key={s.label}
          className="rounded-2xl border border-white/8 bg-white/[0.03] p-4 hover:border-white/15 transition-all"
        >
          <div className="flex items-center gap-2 mb-3">
            <div
              className="w-8 h-8 flex items-center justify-center rounded-xl"
              style={{ background: `${s.color}18` }}
            >
              <i className={`${s.icon} text-sm`} style={{ color: s.color }} />
            </div>
            <span className="text-white/40 text-xs font-semibold">{s.label}</span>
          </div>
          <p className="text-white font-black text-2xl leading-none mb-1" style={{ color: s.color }}>
            {s.value}
          </p>
          <p className="text-white/30 text-xs">{s.sub}</p>
        </div>
      ))}
    </div>
  );
}
